import { memo as Memo, useMemo, useRef, useLayoutEffect } from 'react';
import { gsap } from 'gsap';

//* Helpers
import breakString from '@helpers/breakString';

//* Components
import Text from '@/components/global/Text';
import Image from '@components/global/Image';
import CustomLink from '@/components/global/CustomLink';

//* Styles
import PartnersStyle from './style';

const Partners = Memo(({ active, darkMode, ...data }) => {
	//! Refs
	const topRef1 = useRef();
	const topRef2 = useRef();

	//! Animation
	const tl = useMemo(() => gsap.timeline({ delay: 0.1 }), []);

	useLayoutEffect(() => {
		if (!topRef1.current || !topRef2.current) return;

		const targets = [...(topRef1.current.children || []), ...(topRef2.current.children || [])];
		const italicTarget = topRef1.current.children[1];

		if (active) {
			tl.clear()
				.set(targets, { opacity: 0 })
				.to(targets, { opacity: 1, duration: 0, stagger: 0.1 })
				.to(italicTarget, { fontStyle: 'italic', fontWeight: 300, duration: 0, delay: 0.4 }, 0.2)
				.restart(true);
		} else {
			tl.clear().to(targets, { opacity: 0, duration: 0, stagger: 0 }).to(italicTarget, { fontStyle: 'normal', fontWeight: 300, duration: 0 }, 0).restart(true);
		}
	}, [active, tl]);

	return (
		<PartnersStyle>
			<Text
				tag={'h2'}
				ref={topRef1}
				className={`h2 font-poppins font-semi-bold title`}>
				{breakString(data.title)}
			</Text>

			<div
				ref={topRef2}
				className={'partnersLogoCont'}>
				{data.items.map((item, ind) => {
					return (
						<div
							key={ind}
							className={'partnersLogoItem'}>
							{item.url ? (
								<CustomLink
									external
									url={item.url}
									className={`crCircle ${darkMode ? 'darkMode' : ''}`}>
									<Image
										src={item.logo.src}
										alt={item.logo.alt}
										className={'partnersLogoWrap'}
									/>
								</CustomLink>
							) : (
								<div className={`crCircle ${darkMode ? 'darkMode' : ''}`}>
									<Image
										src={item.logo.src}
										alt={item.logo.alt}
										className={'partnersLogoWrap'}
									/>
								</div>
							)}
						</div>
					);
				})}
			</div>
		</PartnersStyle>
	);
});

export default Partners;
